const onboardingApiBaseUrl = import.meta.env.VITE_ONBOARDING_API_BASE_URL;

export const ONBOARDING_API_BASE_URL = `${onboardingApiBaseUrl}/v1`;

export enum API_ERROR_CODES {
  GENERIC = 'GENERIC',
  LOGIN_TOO_MANY_ATTEMPTS = 'LOGIN_TOO_MANY_ATTEMPTS',
  LOGIN_GENERIC = 'LOGIN_GENERIC',
  PASSWORD_BLACKLISTED = 'PASSWORD_BLACKLISTED',
  PEGA_TOKEN_EXPIRED = 'PEGA_TOKEN_EXPIRED',
}

/**
 * IMPORTANT
 * These are only used when the server returns an error without any message.
 * If it returns a message we display it as is.
 * In the future the server should return error codes like these, which the front end then translates.
 */
export const API_ERROR_MESSAGES = {
  [API_ERROR_CODES.GENERIC]:
    'Something went wrong, please try again later or contact our Customer Management Team on +44 (0)20 3003 8844.',
  [API_ERROR_CODES.LOGIN_TOO_MANY_ATTEMPTS]:
    'Your account is locked due to multiple failed login attempts. Please try again later or contact our Customer Management Team on +44 (0)20 3003 8844.',
  [API_ERROR_CODES.LOGIN_GENERIC]:
    'The login details you have entered do not match our records. Please try again or contact our Customer Management Team on +44 (0)20 3003 8844.',
  [API_ERROR_CODES.PASSWORD_BLACKLISTED]: 'This password is too common. Please choose a different one.',
  [API_ERROR_CODES.PEGA_TOKEN_EXPIRED]: '', // No message required as we boot back to the login
};

export * from './apiGetOneTimeToken.ts';
export * from './apiGetPlatformToken.ts';
export * from './apiIdentitySearch.ts';
export * from './apiLogin.ts';
export * from './apiOtpResend.ts';
export * from './apiOtpVerify.ts';
export * from './apiResetPasswordRequest.ts';
export * from './apiSetPassword.ts';
